import Moment from "react-moment";

function JobSummarySidebar(props) {
  return (
    <div
      className="bg-light rounded p-5 mb-4 wow slideInUp"
      data-wow-delay="0.1s"
    >
      <h4 className="mb-4">Job Summary</h4>
      <p>
        <i className="fa fa-angle-right text-primary me-2"></i>
        Published On:{" "}
        <Moment format="D MMM, YYYY" withTitle>
          {new Date(props.details.publishedDate)}
        </Moment>
      </p>
      <p>
        <i className="fa fa-angle-right text-primary me-2"></i>
        Vacancy: {props.details.vacancy} Position
      </p>
      <p>
        <i className="fa fa-angle-right text-primary me-2"></i>Job Nature:{" "}
        {props.details.jobNature}
      </p>
      <p>
        <i className="fa fa-angle-right text-primary me-2"></i>Salary:{" "}
        {props.details.salary}
      </p>
      <p>
        <i className="fa fa-angle-right text-primary me-2"></i>
        Location: {props.details.location}
      </p>
      <p className="m-0">
        <i className="fa fa-angle-right text-primary me-2"></i>End Date:{" "}
        <Moment format="D MMM, YYYY" withTitle>
          {new Date(props.details.endDate)}
        </Moment>
      </p>
    </div>
  );
}

export default JobSummarySidebar;
